/* MBM forms adapter (window.MBMForms) — extracted verbatim from the prototype main.js.
   Basin backend + per-kind confirmation copy. The Get-an-Offer flow calls MBMForms.send(). */
/* Machine v0.1 (2026-09-23): product pages load this file twice (theme.liquid
   and the Make Offer snippet), which ran the whole adapter twice and doubled
   every seller_cta_click. Second load is now a no-op. */
if (window.MBMForms && window.MBMForms.__loaded) { /* already initialised */ } else
window.MBMForms = (function () {
  var INBOX = "mintbymemphis@gmail.com";                                  /* public-facing email shown to users */
  var smooth = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ===== ONE BACKEND CONFIG (the single place to swap providers) ========
     PRODUCTION = Basin: set provider:"basin" and paste the three form
     endpoints. Each Basin form owns its subject + autoresponder + notification
     settings in the Basin dashboard, which is why there is one endpoint per
     lead "kind". "formsubmit" is the PROTOTYPE-ONLY fallback for local testing
     (it has the known AJAX autoresponder limitation, so it is NOT production).
     ===================================================================== */
  var BACKEND = {
    provider: "basin",                                        /* LIVE on Basin (set "formsubmit" to fall back) */
    formsubmit: "https://formsubmit.co/ajax/mintbymemphis@gmail.com",
    basin: {
      acquisition: "https://usebasin.com/f/1b8c61e498c1",   /* MBM Acquisition (Get an Offer) form 71040 */
      offer:       "https://usebasin.com/f/58c31b991cc5",   /* MBM Make an Offer form 71041 */
      general:     "https://usebasin.com/f/f7326e5915ff",   /* MBM General (Newsletter, Private Client List) form 71042 — open, no captcha */
      contact:     "https://usebasin.com/f/d0838e4618ee"    /* MBM Contact + Vault inquiries form 71602 — Turnstile-protected */
    }
  };

  /* Internal-only Basin form (73377), autoresponder OFF. Used for notifications
     TO US that must never generate a reply to a customer. Kept separate from the
     customer-facing forms above so ops noise can never bury a real submission. */
  var NOTIFY_ENDPOINT = "https://usebasin.com/f/ca97e3bf5142";

  /* ===== PER-FORM CONFIRMATION COPY (single source of truth) ============
     For Basin: paste each kind's text into that Basin form's Autoresponder.
     For the FormSubmit prototype fallback it is sent inline as _autoresponse
     (canonical copy; not a live guarantee on AJAX). No em dashes. ======== */
  var CONFIRMATIONS = {
    acquisition:
      "Thank you for presenting your collection to Mint By Memphis.\n\n" +
      "We personally review everything that comes in, and we will reply to you by email, usually within 48 hours. If it is a fit, we will follow up with a fair offer. If it is not the right fit for us, we will tell you honestly.\n\n" +
      "Prefer to trade? Vault Credit lets you apply the full value of your accepted offer toward any eligible card at Mint By Memphis, turning the cards you are done with into the ones you want. The number is the same as cash, which is always an option too.\n\n" +
      "Feel free to reply to this email any time with photos or anything else you would like us to know.\n\n" +
      "Butch and Tamera\nMint By Memphis Co.",
    offer:
      "Thank you for your offer at Mint By Memphis.\n\n" +
      "A real person will review it and reply by email, usually within 48 hours. If we can make it work, we will send you a secure checkout link at the agreed price. The listed price remains available any time if you would prefer to buy now.\n\n" +
      "Butch and Tamera\nMint By Memphis Co.",
    general:
      "Thank you for reaching out to Mint By Memphis.\n\n" +
      "This is a quick confirmation that we received what you sent. If it needs a reply, a real person (us) will get back to you by email, usually within 48 hours.\n\n" +
      "We are family-owned, and we appreciate you taking the time to connect with us.\n\n" +
      "Butch and Tamera\nMint By Memphis Co."
  };

  /* ===== Shared Cloudflare Turnstile mount ==============================
     One helper for every protected form: injects api.js once, renders the
     widget into `el` when the API is ready, and returns a token getter to
     call at submit time. Safe to call for a missing el (returns ""-getter). */
  var TURNSTILE_SITEKEY = "0x4AAAAAADtEflh5kBgKCKOO";
  function turnstileMount(el) {
    if (!el) return function () { return ""; };
    if (!document.getElementById("cf-turnstile-api")) {
      var s = document.createElement("script");
      s.id = "cf-turnstile-api";
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true; s.defer = true;
      document.head.appendChild(s);
    }
    var id = null, tries = 0;
    (function attempt() {
      if (window.turnstile && typeof window.turnstile.render === "function") {
        try { id = window.turnstile.render(el, { sitekey: TURNSTILE_SITEKEY, theme: "dark", "refresh-expired": "auto" }); } catch (e) {}
      } else if (tries++ < 40) { setTimeout(attempt, 200); }
    })();
    return function () {
      try { return (window.turnstile && id !== null) ? (window.turnstile.getResponse(id) || "") : ""; }
      catch (e) { return ""; }
    };
  }

  /* ⭐NO SILENT FALLBACK (2026-08-05). This used to return BACKEND.basin.general
     for ANY unrecognized kind, which quietly delivered a lead to the wrong form
     with the wrong autoresponder and no way to notice. That already happened: a
     purchase confirmation landed in MBM General on 2026-07-24. An unknown kind is
     a wiring bug, not a routing preference, so return "" and let send() reject.
     The caller then shows the mailto fallback, so the lead still reaches us.
     Known kinds are exactly the keys of BACKEND.basin. If you add a Basin form,
     add it there; do NOT reintroduce a default. */
  /* ===== ATTRIBUTION (first-touch, persisted) ==========================
     Records HOW a visitor arrived so a lead can be credited to the boost,
     post, or search that produced it. This file loads from BOTH layouts, so
     capture runs on the LANDING page, not only where a form happens to live.

     FIRST touch is the one we keep: a seller can see a boosted post Monday,
     come back through Google on Thursday, and submit. The boost earned that
     lead. LAST touch is kept too and only reported when it differs.

     Complements the seller's own "How did you hear about us?" answer, which
     decays to "Google" for exactly the case above. This half is deterministic.

     ⚠️ Basin's webhook body is FLAT (submitted fields sit beside metadata), so
     these labels deliberately avoid Basin's reserved keys: id, form_id, spam,
     spam_reason, timestamp, ip, origin, attachments, form_name, project_name,
     geocoded_*. Never name a field "origin" here.

     EVERY path is guarded: storage denied, blocked cookies, or a malformed URL
     all degrade to "no attribution". This must never be able to break a lead. */
  var ATTR_KEY = "mbm_attr_v1";
  var ATTR_WINDOW_DAYS = 90;

  function attrRead() {
    try { return JSON.parse(window.localStorage.getItem(ATTR_KEY) || "null"); } catch (e) { return null; }
  }
  function attrWrite(o) {
    try { window.localStorage.setItem(ATTR_KEY, JSON.stringify(o)); } catch (e) {}
  }

  /* ===== URL PRIVACY (SELLER-FUNNEL-POST-LAUNCH-1, 2026-10-15) ============
     The landing URL and the referrer used to be stored and sent verbatim,
     query string included. A seller can land here through a URL that carries
     an OAuth code, an access token, a session id or a reset link (the
     2026-10-12 live test captured an eBay auth callback's code=). None of
     that is attribution. From here on:
       - the query string is reduced to an ALLOWLIST of attribution params:
         the five utm_* keys the printed QR codes and estate-partner links
         use, plus the site's own vault= routing switch. Everything else is
         dropped whatever it is called, so no denylist of secret-looking
         names is what keeps secrets out
       - names match lowercase AFTER decoding (UTM_Source, utm%5Fsource and
         utm_source are one key); the first occurrence of a repeated key
         wins; values are capped and may never contain an "@"
       - the referrer keeps scheme, host and path only: no query, no
         fragment, no userinfo
       - fragments are never stored (the landing path is split on "#")
       - a visitor's existing 90-day store is scrubbed through the same
         functions on the next page load and again on read, so a value
         captured before this release cannot reach a payload either.
         source / medium / campaign / content / term / at are left as they
         were: this scrubs URLs, it does not re-attribute anyone.
     Field labels sent to Basin are unchanged, so historical rows still join.
     Every function degrades to "" on anything it cannot parse. */
  var ATTR_PARAM_ALLOW = { utm_source: 1, utm_medium: 1, utm_campaign: 1,
                           utm_content: 1, utm_term: 1, vault: 1 };
  var ATTR_VALUE_MAX = 100, ATTR_PATH_MAX = 200;
  var has = Object.prototype.hasOwnProperty;

  function attrSafeValue(v) {
    try {
      v = String(v == null ? "" : v).replace(/[\u0000-\u001f\u007f]/g, "");
      if (!v || v.length > ATTR_VALUE_MAX || v.indexOf("@") !== -1) return "";
      return v;
    } catch (e) { return ""; }
  }
  function attrSafePath(p) {
    try {
      p = String(p == null ? "" : p).split("#")[0].split("?")[0];
      if (p.charAt(0) !== "/") p = "/" + p;
      return p.slice(0, ATTR_PATH_MAX);
    } catch (e) { return "/"; }
  }
  /* "?a=1&b=2" -> only allowlisted params, canonically re-encoded; "" if none */
  function attrSafeQuery(search) {
    var out = [], seen = {};
    try {
      new URLSearchParams(String(search == null ? "" : search)).forEach(function (v, k) {
        var key = String(k).toLowerCase();
        if (!has.call(ATTR_PARAM_ALLOW, key) || has.call(seen, key)) return;
        var val = attrSafeValue(v);
        if (!val) return;
        seen[key] = 1;
        out.push(encodeURIComponent(key) + "=" + encodeURIComponent(val));
      });
    } catch (e) { return ""; }
    return out.length ? "?" + out.join("&") : "";
  }
  function attrSafeLanding(pathname, search) {
    return attrSafePath(pathname) + attrSafeQuery(search);
  }
  /* any URL -> scheme://host/path, or "" when it has no host or cannot parse */
  function attrSafeReferrer(ref) {
    try {
      ref = String(ref == null ? "" : ref);
      if (!ref) return "";
      var u = new URL(ref);
      if (!u.hostname) return "";
      return u.protocol + "//" + u.hostname + attrSafePath(u.pathname);
    } catch (e) { return ""; }
  }
  /* a stored touch of any age or shape -> the same touch with safe URLs only */
  function attrSafeTouch(t) {
    if (!t || typeof t !== "object") return t;
    try {
      var l = String(t.landing == null ? "" : t.landing), i = l.indexOf("?");
      t.landing = l ? attrSafeLanding(i === -1 ? l : l.slice(0, i), i === -1 ? "" : l.slice(i)) : "";
      t.referrer = attrSafeReferrer(t.referrer);
      t.campaign = attrSafeValue(t.campaign);
      t.content = attrSafeValue(t.content);
      t.term = attrSafeValue(t.term);
    } catch (e) { t.landing = ""; t.referrer = ""; }
    return t;
  }

  /* what this particular page view says about where the visitor came from */
  function attrTouch() {
    var q = {};
    try {
      /* first occurrence of a repeated key wins, the same rule the stored
         landing query uses, so source and landing can never disagree */
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        var key = String(k).toLowerCase();
        if (!has.call(q, key)) q[key] = v;
      });
    } catch (e) { q = {}; }

    var src = attrSafeValue(q.utm_source), med = attrSafeValue(q.utm_medium);

    /* paid click ids still identify the platform when the utm tags are missing,
       which is the common case on a boosted post shared onward by someone else */
    if (!src) {
      if (q.fbclid) { src = "facebook"; med = med || "paid"; }
      else if (q.gclid || q.gbraid || q.wbraid) { src = "google"; med = med || "paid"; }
      else if (q.ttclid) { src = "tiktok"; med = med || "paid"; }
      else if (q.igshid) { src = "instagram"; med = med || "social"; }
      else if (q.mkevt || q.mkcid) { src = "ebay"; med = med || "referral"; }
    }

    /* the referrer HOST still credits the source exactly as before; only what
       gets STORED is reduced to scheme://host/path (URL privacy, above) */
    var ref = "", refHost = "";
    try {
      if (document.referrer) {
        var ru = new URL(document.referrer);
        if (ru.hostname && ru.hostname !== window.location.hostname) {
          refHost = ru.hostname;
          ref = attrSafeReferrer(document.referrer);
        }
      }
    } catch (e) {}

    /* no tags, but an outside site sent them: credit that host */
    if (!src && refHost) {
      src = attrSafeValue(refHost.replace(/^www\./, "")); med = med || "referral";
    }

    /* SELLER-CONVERSION-1 (2026-10-10, NEW-5): the referrer-less /?vault=sell
       inference ("no referrer + vault=sell = QR scan") is removed. Email and
       messenger clicks, typed URLs and privacy browsers all arrive without a
       referrer, so the rule over-credited QR. The printed QR is retagged to
       /?vault=sell&utm_source=qr&utm_medium=qr and is credited above through
       utm_source like every other tagged touch. Untagged, referrer-less loads
       read as direct. */
    if (!src) src = "direct";

    return {
      source: src,
      medium: med,
      campaign: attrSafeValue(q.utm_campaign),
      content: attrSafeValue(q.utm_content),
      term: attrSafeValue(q.utm_term),
      referrer: ref,
      landing: attrSafeLanding(window.location.pathname, window.location.search),
      at: new Date().toISOString()
    };
  }

  function attrLabel(t) {
    if (!t) return "";
    var bits = [t.source];
    if (t.medium) bits.push(t.medium);
    if (t.campaign) bits.push(t.campaign);
    if (t.content) bits.push(t.content);
    return bits.join(" / ");
  }

  function attrCapture() {
    try {
      var now = attrTouch();
      var store = attrRead();
      var stale = !store || !store.first ||
        (Date.now() - Date.parse(store.first.at || 0)) > ATTR_WINDOW_DAYS * 864e5;
      if (stale) { store = { first: now, last: now }; }
      else {
        /* URL privacy: scrub what an earlier release stored for this visitor
           (raw landing query, raw referrer). Never re-attributes: source,
           medium, campaign and the first-touch time are left exactly as is */
        store.first = attrSafeTouch(store.first);
        if (store.last) store.last = attrSafeTouch(store.last);
        /* internal page-to-page navigation reads as "direct"; never let it
           overwrite a real last touch */
        if (now.source !== "direct") { store.last = now; }
      }
      attrWrite(store);
    } catch (e) {}
  }

  /* labelled fields for a lead payload; {} when nothing is known */
  function attribution() {
    try {
      var store = attrRead();
      if (!store || !store.first || typeof store.first !== "object") return {};
      /* URL privacy: read through the scrubber too, so even a store this
         page load has not rewritten yet can only yield safe URLs */
      var f = attrSafeTouch(store.first), l = store.last ? attrSafeTouch(store.last) : null;
      var out = {}, first = attrLabel(f), last = attrLabel(l);
      out["First touch"] = first;
      if (last && last !== first) out["Last touch"] = last;
      if (f.landing) out["Landing page"] = f.landing;
      if (f.referrer) out["Referrer"] = f.referrer;
      if (f.term) out["First touch term"] = f.term;
      /* Machine v0.1 (2026-09-23): the same facts as explicit, separately
         filterable fields (Basin search + Vault OS routing). ADDITIVE ONLY;
         the labelled fields above are unchanged so historical rows still join. */
      out["First touch source"] = f.source || "";
      out["First touch medium"] = f.medium || "";
      if (f.campaign) out["First touch campaign"] = f.campaign;
      if (f.content) out["First touch content"] = f.content;
      if (l && l.source) {
        out["Last touch source"] = l.source || "";
        out["Last touch medium"] = l.medium || "";
        if (l.campaign) out["Last touch campaign"] = l.campaign;
        if (l.content) out["Last touch content"] = l.content;
        if (l.landing) out["Last touch landing"] = l.landing;
      }
      return out;
    } catch (e) { return {}; }
  }

  attrCapture();   /* runs on every page load, site-wide */

  /* ===== PRODUCT ORIGIN (Machine v0.1, 2026-09-23) =========================
     Which card the visitor was looking at before they came to sell. Written by
     mbm-origin.js on product pages (mbm_origin_v1, 7-day window); read here as
     labelled, additive Basin fields. Never anything about the visitor. */
  var ORIGIN_KEY = "mbm_origin_v1", ORIGIN_DAYS = 7;
  function origin() {
    try {
      var o = JSON.parse(window.localStorage.getItem(ORIGIN_KEY) || "null");
      if (!o || !o.at || (Date.now() - Date.parse(o.at)) > ORIGIN_DAYS * 864e5) return {};
      var out = {};
      if (o.title) out["Origin product"] = o.title;
      if (o.url) out["Origin URL"] = o.url;
      if (o.id) out["Origin product id"] = o.id;
      if (o.player) out["Origin player"] = o.player;
      if (o.year) out["Origin year"] = o.year;
      if (o.set) out["Origin set"] = o.set;
      if (o.grade) out["Origin grade"] = o.grade;
      if (o.sport) out["Origin sport"] = o.sport;
      if (o.price) out["Origin price"] = o.price;
      if (o.ref) out["Origin referring page"] = o.ref;
      if (o.at) out["Origin seen at"] = o.at;
      return out;
    } catch (e) { return {}; }
  }

  /* referring page inside the site (path only), for "which page sent them" */
  function referringPage() {
    try { if (document.referrer && new URL(document.referrer).hostname === window.location.hostname) return new URL(document.referrer).pathname; } catch (e) {}
    return "";
  }

  /* ===== GA4 TELEMETRY (Phase 1, 2026-08-24) ============================
     Contract: docs/EVENT-SCHEMA.md v1 in the repo (and the Phase-1 evidence
     package). GA4 is TELEMETRY ONLY; Basin remains the lead ledger.

     PRIVACY IS ENFORCED HERE, not at the call sites: params pass through an
     ALLOWLIST, values are truncated, and any value that looks like an email
     is dropped. Nothing else ever reaches gtag from MBM code. Do not add a
     param name without updating the schema doc AND the unit test. */
  var TRACK_ALLOWED = { cta: 1, page_path: 1, trigger: 1, lead_ref: 1, photos: 1,
                        turnstile: 1, reason: 1, first_touch_source: 1, heard: 1,
                        event_version: 1, transport_type: 1 };
  function track(name, params) {
    try {
      if (typeof window.gtag !== "function") return;
      var out = { event_version: "1" };
      Object.keys(params || {}).forEach(function (k) {
        if (!TRACK_ALLOWED[k]) return;
        var v = params[k];
        if (typeof v === "number") { out[k] = v; return; }
        v = String(v == null ? "" : v);
        if (!v || v.indexOf("@") !== -1) return;   /* never an email, never empty */
        out[k] = v.slice(0, 100);
      });
      window.gtag("event", name, out);
    } catch (e) { /* telemetry must never break the page */ }
  }

  /* first-touch source label only (e.g. "qr / qr", "instagram / bio") — no
     referrer URLs, no landing paths with query strings, nothing personal */
  function firstTouchSource() {
    try {
      var store = attrRead();
      if (!store || !store.first) return "";
      var t = store.first, bits = [t.source];
      if (t.medium) bits.push(t.medium);
      return bits.join(" / ");
    } catch (e) { return ""; }
  }

  /* seller_cta_click: one delegated listener for every [data-cta] element,
     site-wide (this file loads from every layout). transport=beacon so the
     event survives the navigation the click starts. Repeat clicks are real
     clicks; no dedupe here by design (see schema doc). */
  document.addEventListener("click", function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest("[data-cta]");
      if (!el) return;
      track("seller_cta_click", { cta: el.getAttribute("data-cta"),
                                  page_path: window.location.pathname,
                                  transport_type: "beacon" });
    } catch (err) {}
  }, true);

  /* seller_cta_view (Machine v0.1): a [data-cta] element scrolled into view,
     once per cta value per page load. Same params as seller_cta_click, so the
     allowlist and schema version are unchanged. Denominator for click-through. */
  (function () {
    try {
      if (!("IntersectionObserver" in window)) return;
      var seenCta = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var cta = en.target.getAttribute("data-cta") || "";
          if (!cta || seenCta[cta]) return;
          seenCta[cta] = 1;
          track("seller_cta_view", { cta: cta, page_path: window.location.pathname });
          io.unobserve(en.target);
        });
      }, { threshold: 0.6 });
      var arm = function () { Array.prototype.forEach.call(document.querySelectorAll("[data-cta]"), function (el) { io.observe(el); }); };
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm); else arm();
    } catch (e) {}
  })();

  function endpointFor(kind) {
    if (BACKEND.provider === "basin") {
      var url = BACKEND.basin && BACKEND.basin[kind];
      if (!url && window.console && window.console.error) {
        window.console.error("MBMForms: unknown form kind " + JSON.stringify(kind) +
                             "; refusing to guess an endpoint. Add it to BACKEND.basin.");
      }
      return url || "";
    }
    return BACKEND.formsubmit;   /* FormSubmit uses one endpoint for every kind */
  }

  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim()); }

  function mailtoFor(subject, data) {
    var lines = [];
    Object.keys(data).forEach(function (k) { if (data[k] !== "" && data[k] != null) lines.push(k + ": " + data[k]); });
    return "mailto:" + INBOX + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(lines.join("\r\n"));
  }

  function clearError(scope) { var e = scope.querySelector(".form-error"); if (e) e.hidden = true; }
  function showError(scope, subject, data, anchor) {
    var e = scope.querySelector(".form-error");
    if (!e) {
      e = document.createElement("p");
      e.className = "form-error";
      e.setAttribute("role", "alert");
      var ref = anchor || scope.querySelector('button[type="submit"], [type="submit"], button:not([type])');
      if (ref && ref.parentNode) ref.parentNode.insertBefore(e, ref.nextSibling); else scope.appendChild(e);
    }
    e.innerHTML = "We couldn't send that just now. Please email us at <a href=\"" + mailtoFor(subject, data) + "\">" + INBOX + "</a> and we'll take care of you right away.";
    e.hidden = false;
    return e;
  }

  /* send(subject, data, opts) -> Promise; resolves on HTTP 200, rejects otherwise.
     opts.kind    "acquisition" | "offer" | "general" (default "general") picks
                  the backend endpoint + the default confirmation copy.
     opts.replyTo reply-to email (defaults to data.Email / data.email).
     opts.autoresponse overrides the per-kind confirmation copy. */
  function send(subject, data, opts) {
    opts = opts || {};
    if (!window.fetch) return Promise.reject(new Error("no-fetch"));
    var kind = opts.kind || "general";
    var endpoint = endpointFor(kind);
    if (!endpoint) return Promise.reject(new Error("no-endpoint"));      /* unknown kind, or Basin not configured yet */
    var replyTo = opts.replyTo || data.Email || data.email || "";
    var autoresponse = opts.autoresponse || CONFIRMATIONS[kind] || CONFIRMATIONS.general;

    var body;
    if (BACKEND.provider === "basin") {
      /* Basin captures all fields; reply-to, subject and autoresponder are set
         once in the Basin dashboard. We pass conventional fields it templates on. */
      body = Object.assign({}, data, { subject: subject, email: replyTo });
    } else {
      body = Object.assign({ _subject: subject, _template: "table", _captcha: "false" }, data);
      if (replyTo) body._replyto = replyTo;
      if (autoresponse) body._autoresponse = autoresponse;
    }

    return new Promise(function (resolve, reject) {
      var settled = false;
      var killed = setTimeout(function () { if (!settled) { settled = true; reject(new Error("timeout")); } }, 12000);
      fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () { if (settled) return; settled = true; clearTimeout(killed); resolve(); })
        .catch(function (err) { if (settled) return; settled = true; clearTimeout(killed); reject(err); });
    });
  }

  /* wire(form, opts): standard forms.
     opts = { subject, kind?, collect(): data|null, onSuccess(), autoresponse?, scope?, errorAnchor? } */
  function wire(form, opts) {
    if (!form) return;
    var scope = opts.scope || form;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var data = opts.collect();
      if (!data) return; /* invalid; collect() already flagged the fields */
      var btn = form.querySelector('button[type="submit"], [type="submit"], button:not([type])');
      var label = btn ? btn.textContent : "";
      var hp = form.querySelector('[name="_honey"]');
      if (hp && hp.value) { opts.onSuccess(); return; } /* bot honeypot */
      if (btn) { btn.disabled = true; btn.textContent = "Sending…"; }
      clearError(scope);
      var ar = typeof opts.autoresponse === "function" ? opts.autoresponse(data) : opts.autoresponse;
      send(opts.subject, data, { autoresponse: ar, kind: opts.kind }).then(function () {
        opts.onSuccess();
      }, function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        showError(scope, opts.subject, data, opts.errorAnchor || btn);
      });
    });
  }

  /* ===== NEWSLETTER SIGNUP NOTIFIER (2026-08-05) ========================
     Every newsletter box on the site (/pages/newsletter "Inner Circle", the
     homepage "Stay Close to the Vault" block, and Dawn's footer signup) is a
     NATIVE SHOPIFY CUSTOMER FORM (form_type=customer). That is deliberate and
     correct: the native post is what puts the subscriber on the Shopify
     marketing list, which is the list we actually email from.

     The gap it left: Shopify sends us no notification for those signups, so
     they were completely invisible in the inbox and the newsletter read as
     broken. An audit on 2026-08-05 found 0 signups on two of the three boxes
     and no way to tell whether that meant "no traffic" or "silently failing".

     Fix: leave the native submit untouched and MIRROR a minimal notification to
     the internal Basin form. Notes:
       - sendBeacon, not fetch: the native form navigates away the instant it
         submits, which aborts an in-flight fetch. sendBeacon is built to
         survive unload.
       - Reply-to is the SUBSCRIBER, so you can just hit reply to welcome them.
         The internal form has its autoresponder OFF, so they get nothing
         automated from this ping.
       - Wrapped in try/catch and never preventDefault: if this notification
         fails for any reason, the real signup still goes through untouched.
       - Shopify's own hCaptcha bot protection (storefront-forms-hcaptcha) also
         listens on this submit, calls preventDefault, then re-submits the form
         itself once the challenge passes. That re-submit does not re-fire submit
         listeners, so we notify exactly once per attempt. The trade-off is that
         we notify on the ATTEMPT, not on confirmed success: if the challenge
         fails, you get a signup notice for a subscriber Shopify never created.
         Over-notifying is the right side to err on here, since the whole point
         is that these signups were previously invisible.
     Do NOT "fix" this by repointing the form at Basin. That would notify us but
     stop building the Shopify marketing list. ========================== */
  function notifyNewsletterSignup(form) {
    var emailEl = form.querySelector('[name="contact[email]"]');
    var email = emailEl ? (emailEl.value || "").trim() : "";
    if (!emailValid(email)) return;                 /* Shopify will reject it anyway */
    var tagsEl = form.querySelector('[name="contact[tags]"]');
    /* ⭐KEEP THIS MINIMAL AND URL-FREE. Basin's SpamCheck AI flags chatty payloads,
       and a spam-flagged submission sends NO notification email at all, so the
       signup would be just as invisible as before. Verified on 2026-08-05: a
       version of this payload carrying window.location.pathname was flagged
       "Content matches spam patterns" every time. This shape mirrors the Basin
       watchdog's alert payload, which has never been flagged. Do not add URLs,
       links, or extra prose fields. */
    var payload = {
      subject: "New newsletter signup",
      email: email,                                 /* reply-to = the subscriber */
      "What happened": "Someone joined the mailing list on the website.",
      "List": tagsEl && tagsEl.value ? tagsEl.value : "(untagged)",
      "Action": "No action needed. They are on the Shopify marketing list. Reply here to welcome them."
    };
    try {
      /* ⭐FORM-ENCODED, NOT JSON (2026-08-05). sendBeacon may only send
         CORS-safelisted content types. An application/json body to another origin
         needs a CORS preflight, and a beacon cannot perform one, so the browser
         drops the request silently WHILE sendBeacon still returns true, which
         means the fetch fallback below never runs either. The first version of
         this shipped with application/json and sent nothing at all.
         URLSearchParams sends application/x-www-form-urlencoded, which is
         safelisted and is exactly what a plain HTML form posts. Do not switch
         this back to JSON. */
      var params = new URLSearchParams();
      Object.keys(payload).forEach(function (k) { params.append(k, payload[k]); });
      var sent = false;
      if (navigator.sendBeacon) { sent = navigator.sendBeacon(NOTIFY_ENDPOINT, params); }
      if (!sent) {
        fetch(NOTIFY_ENDPOINT, { method: "POST", body: params, keepalive: true }).catch(function () {});
      }
    } catch (e) { /* never let a notification failure block a real signup */ }
  }

  function mountNewsletterNotifier() {
    /* form_type=customer is the newsletter signup specifically. Account signup
       is create_customer and login is customer_login, so neither is matched. */
    var markers = document.querySelectorAll('form input[name="form_type"][value="customer"]');
    Array.prototype.forEach.call(markers, function (marker) {
      var form = marker.form || (marker.closest && marker.closest("form"));
      if (!form || form.getAttribute("data-mbm-notify") === "1") return;
      form.setAttribute("data-mbm-notify", "1");
      form.addEventListener("submit", function () { notifyNewsletterSignup(form); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountNewsletterNotifier);
  } else {
    mountNewsletterNotifier();
  }

  return { __loaded: true, INBOX: INBOX, emailValid: emailValid, mailtoFor: mailtoFor, send: send, wire: wire, showError: showError, clearError: clearError, smooth: smooth, config: BACKEND, confirmations: CONFIRMATIONS, endpointFor: endpointFor, turnstileMount: turnstileMount, attribution: attribution, origin: origin, referringPage: referringPage, mountNewsletterNotifier: mountNewsletterNotifier, track: track, firstTouchSource: firstTouchSource,
           urlPrivacy: { landing: attrSafeLanding, referrer: attrSafeReferrer, query: attrSafeQuery, touch: attrSafeTouch } };
})();
